const styles = {
    container: {
        textAlign: 'center',
        margin: 10
    },
    paper: {
        border: 0,
        boxShadow:0,
        padding: 20
    }
  };

  export default styles;


// WEBPACK FOOTER //
// ./src/components/loaders/styles/SpinnerLoaderWithTextStyles.js